function paymentCheckoutMethod() {
  $(document).on("click", ".single-payment-option", function () {
    const $option = $(this);
    const gatewayId = $option.data("gateway");
    $(".single-payment-option").removeClass("selected");
    $option.addClass("selected");
    $("#chosen_payment_gateway").val(gatewayId);
  });

  $(document).on("click", "#button-confirm-payment", function (e) {
    e.preventDefault();
    const stepsCheckoutContainer = document.querySelector(
      ".page-checkout .content-page-checkout"
    );
    const resumeContainer = document.querySelector(
      ".page-checkout .resume-checkout"
    );
    const feedbackContainer = document.querySelector(
      ".page-checkout .feedback-checkout"
    );
    const headerCheckout = document.querySelector(
      ".page-checkout .header-checkout"
    );

    const chosenGateway = $("#chosen_payment_gateway").val();

    if (!chosenGateway) {
      alert("Por favor, selecione um método de pagamento antes de continuar.");
      return;
    }
    const selectedAddr = $(
      ".list-address-options .single-address-option.selected"
    );
    if (!selectedAddr.length) {
      alert("Endereço não encontrado. Volte e selecione um endereço.");
      return;
    }
    const state = selectedAddr.data("state");
    const eircode = selectedAddr.data("eircode");

    if (!state || !eircode) {
      alert("Não foi possível obter o estado ou Eircode do endereço.");
      return;
    }
    $(this).prop("disabled", true).text("Processando…");
    $.post(
      my_ajax_object.ajax_url,
      {
        action: "create_order",
        payment_gateway: chosenGateway,
        state: state,
        eircode: eircode.replace(/\s+/g, ""),
      },
      function (resp) {
        if (resp.success) {
          stepsCheckoutContainer.classList.remove("active");
          resumeContainer.classList.remove("active");
          feedbackContainer.classList.add("active");
          headerCheckout.classList.add("active");
        } else {
          console.log("Erro ao criar o pedido: " + resp.data.message);
          $("#button-confirm-payment")
            .prop("disabled", false)
            .text("Confirmar");
        }
      },
      "json"
    );
  });
}

export { paymentCheckoutMethod };
